import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import PropTypes from 'prop-types';

export const CLASS_ANCHORED = 'MuiSpeedDial--anchored ';

//@mui SpeedDial documentation: https://mui.com/material-ui/api/speed-dial/
//helpful documentation on customization of mui speed dial component: https://smartdevpreneur.com/how-to-customize-mui-speed-dial-size-color-hover/#:~:text=The%20Speed%20Dial%20component%20is%20a%20useful%20way,the%20MUI%20docs%2C%20and%20add%20styling%20to%20it.
//basic implementation example at pages\ApplicationInformation\components\AppInfoedit\htmlLinkInsert.js

const BaseSpeedDial = ({
	anchored = false,
	speedDialProps,
	speedDialActions,
}) => {
	let { classes = {}, ...dialProps } = speedDialProps;
	let arrActions = [...speedDialActions];

	if (anchored) {
		classes.fab = CLASS_ANCHORED + classes.fab;

		arrActions = arrActions.map(action => {
			action.classes = {
				...action.classes,
				fab: CLASS_ANCHORED + action?.classes?.fab,
			};
			return action;
		});
	}

	return (
		<div>
			<SpeedDial {...dialProps} classes={classes}>
				{arrActions.map((action, index) => (
					<SpeedDialAction {...action} key={index} />
				))}
			</SpeedDial>
		</div>
	);
};
//export classes representative of base mui component props for better developer experience
export class SpeedDialProps {
	constructor() {
		this.ariaLabel = undefined;
		this.children = undefined;
		this.classes = undefined;
		this.direction = undefined;
		this.FabProps = {};
		this.hidden = undefined;
		this.icon = undefined;
		this.onClose = undefined;
		this.onOpen = undefined;
		this.open = undefined;
		this.openIcon = undefined;
		this.TransitionComponent = undefined;
		this.transitionDuration = undefined;
		this.TransitionProps = undefined;
		//default styling, reassignable
		this.sx = {
			position: 'relative',

			left: 20,
			'& .MuiFab-primary': {
				width: 'fit-content',
				height: '100%',
				backgroundColor: '#904199', //tech_purple
				color: 'white',
				padding: '.25em',
				borderRadius: '5px',
				'& .MuiSpeedDialIcon-icon': { fontSize: 16 },
				'&:hover': { backgroundColor: '#904199' },
			},
		};
	}
}

//official speedDialActions docs located at https://mui.com/material-ui/api/speed-dial-action/
export class SpeedDialActionProps {
	constructor() {
		this.classes = undefined;
		this.delay = undefined;
		this.FabProps = {};
		this.icon = undefined;
		this.id = undefined;
		this.open = undefined;
		this.tooltipOpen = undefined;
		this.tooltipPlacement = undefined;
		this.tooltipTitle = undefined;
		this.onClick = undefined;
		//default style overRides
		this.sx = {
			width: 'fit-content',
			height: '30px',
			backgroundColor: 'white',
			color: '#904199',
			borderRadius: '5px',
			padding: '.25em',
		};
	}
}

//PropTypes*************************
BaseSpeedDial.propTypes = {
	/**
	 * Determines whether speed dial should be anchored to the navigation drawer and change position when drawer is closed or opened.
	 */
	anchored: PropTypes.bool,
	speedDialProps: PropTypes.instanceOf(SpeedDialProps).isRequired,
	speedDialActions: PropTypes.arrayOf(
		PropTypes.shape({ type: PropTypes.oneOf([SpeedDialActionProps]) })
	).isRequired,
};

export default BaseSpeedDial;
